module.exports = __webpack_public_path__ + "img/mastercard-200px.fbf4b50c.webp";